<template>
  <div class="listWrapper">
    <div class="listContentWrapper">
      <div class="listHeader">
        <div class="headerDiv">
          <div class="headerInputDiv">
            <input class="headerInputText" v-model="inputText" placeholder="제목검색" type="text" v-on:keyup.enter="onSearchTitle">
            <img class="headerInputSearchImg" v-bind:src="style.searchInputBackgroundImg" v-on:click="onSearchTitle">
          </div>
          <input class="headerInputButton" type="button" value="광고 올리기" v-on:click="goToEnroll">
        </div>
        <div class="headerSearchTextValidText">
          <span v-show="validText.searchTextNoBlank">* 빈칸은 검색어로 입력할 수 없습니다.</span>
        </div>
        <div class="headerInfosDiv">
          <div class="headerInfo" v-for="info in headerInfos" v-bind:key="info.state" >
            <span class="infoText">{{info.text}}</span>
            <span class="infoValue">{{info.value}}</span>개
          </div>
        </div>
      </div>
      <div class="listDiv">
        <advertise v-for="item in advertiseList" v-bind:key="item.adId" v-bind="item"></advertise>
        <div class="listNoDataDiv" v-show="advertiseList.length === 0">
          <span>게시한 광고가 없습니다.</span>
        </div>
      </div>
      <div class="listFooter">
        <div class="pagePreviousDiv">
          <img class="pagePreviousIcon" v-show="isShowPreviousPagePointer" v-on:click="setShowPages(-10)" v-bind:src="pagePreviousIcon" />
        </div>
        <span class="page" v-for="index in showPageArray" v-bind:key="index" v-bind:class="{selectedPage: contentPageIndex === index}" v-on:click="getSelectedPageData(index)">{{index + 1}}</span>
        <div class="pageNextDiv">
          <img class="pageNextIcon" v-show="isShowNextPagePointer" v-on:click="setShowPages(10)" v-bind:src="pageNextIcon" />
        </div>
      </div>
    </div>
    <board-footer></board-footer>
  </div>
</template>

<script>
import advertise from '../elements/advertise'
import boardFooter from '../elements/boardFooter'
import store from '../../../store'

export default {
  components: {
    'advertise': advertise,
    'board-footer': boardFooter
  },
  data () {
    return {
      // 예시데이터
      advertiseList: [],
      inputText: '',
      searchText: '',
      validText: {
        searchTextNoBlank: false
      },
      headerInfos: [],
      contentPageIndex: 0,
      showPageArray: [],
      showPageArrayIndexStart: 0,
      isShowNextPagePointer: false,
      isShowPreviousPagePointer: false,
      totalPageNumber: 0,
      pagePreviousIcon: null,
      pageNextIcon: null,
      style: {
        searchInputBackgroundImg: require('@/assets/img/search_input_icon.png')
      }
    }
  },
  methods: {
    onSearchTitle: async function () {
      this.validText.searchTextNoBlank = false
      this.searchText = this.inputText
      if(this.searchTextValid(this.searchText)) {
        try {
          let adListResponse = await store.dispatch('adListApi', {pageIndex: 0, searchText: this.searchText})
          let adCountsResponse = await store.dispatch('adCountsApi', {searchText: this.searchText})
          this.totalPageNumber = adListResponse.data.data.totalPages
          this.setPageInfo(adListResponse.data.data)
          this.setAdCnt(adCountsResponse.data.data)
          this.setAdList(adListResponse.data.data.content)
        } catch (error) {
          console.log(error.response)
        }
      }
    },
    searchTextValid: function (searchText) {
      if (searchText !== '' && searchText.trim() === '') {
        this.validText.searchTextNoBlank = true
        return false
      }
      return true
    },
    goToEnroll: function () {
      this.$router.push({name: 'enroll'})
    },
    setAdList: function (listData) {
      this.advertiseList = []
      for(var i = 0; i < listData.length; i++) {
        let ad = listData[i]
        let startDate = this.$moment(ad.startAt.split(' ')[0], 'YYYY-MM-DD').format('yy.MM.DD')
        // DB에 저장된 값은 다음날 00시 이므로 -1처리를 해줘야됨
        let endDate = this.$moment(ad.endAt.split(' ')[0], 'YYYY-MM-DD').add(-1, 'days').format('yy.MM.DD')
        this.advertiseList.push(
          {
            adId: ad.id,
            state: ad.status,
            startDate: startDate,
            endDate: endDate,
            titleImgUrl: ad.questionSource,
            titleText: ad.questionText,
            totalExposed: ad.exposedCnt,
            totalAnswered: ad.answerCnt
          }
        )
      }
    },
    setAdCnt: function (counts) {
      let headerInfos = [
        {
          state: 'ALL',
          text: '총 업로드 광고',
          value: 0
        },
        {
          state: 'TEMPORARY',
          text: '임시저장된 광고',
          value: 0
        },
        {
          state: 'WAITING',
          text: '대기중인 광고',
          value: 0
        },
        {
          state: 'ON_PROGRESS',
          text: '진행중인 광고',
          value: 0
        },
        {
          state: 'COMPLETED',
          text: '완료된 광고',
          value: 0
        },
        {
          state: 'STOPPED',
          text: '정지된 광고',
          value: 0
        }
      ]
      headerInfos[0].value = counts.all
      headerInfos[1].value = counts.temporary
      headerInfos[2].value = counts.waiting
      headerInfos[3].value = counts.onProgress
      headerInfos[4].value = counts.completed
      headerInfos[5].value = counts.stoppedByAdmin + counts.stoppedInsufficientPoints

      this.headerInfos = headerInfos
    },
    setPageInfo: function () {
      this.showPageArray = []
      if(this.totalPageNumber <= this.showPageArrayIndexStart + 10) {
        for (var i = this.showPageArrayIndexStart; i < this.totalPageNumber; i++) {
          this.showPageArray.push(i)
          this.isShowNextPagePointer = false
        }
      } else {
        // eslint-disable-next-line no-redeclare
        for (var i = this.showPageArrayIndexStart; i < this.showPageArrayIndexStart + 10; i++) {
          this.showPageArray.push(i)
        }
        this.isShowNextPagePointer = true
      }
      this.isShowPreviousPagePointer = this.showPageArrayIndexStart !== 0
    },
    getSelectedPageData: async function (selectedPageIndex) {
      this.contentPageIndex = selectedPageIndex
      try {
        let adListResponse = await store.dispatch('adListApi', {pageIndex: selectedPageIndex, searchText: this.searchText})
        this.setAdList(adListResponse.data.data.content)
      } catch (error) {
        console.log(error.response)
      }
    },
    setShowPages: function (showPageNumber) {
      this.showPageArrayIndexStart += showPageNumber
      this.setPageInfo()
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let adListResponse = await store.dispatch('adListApi', {pageIndex: 0, searchText: null})
      let adCountsResponse = await store.dispatch('adCountsApi', {searchText: null})
      next(vm => {
        vm.totalPageNumber = adListResponse.data.data.totalPages
        vm.setPageInfo(adListResponse.data.data)
        vm.setAdCnt(adCountsResponse.data.data)
        vm.setAdList(adListResponse.data.data.content)
      })
    }catch (error) {
      console.log(error.response)
    }
  },
  created: function () {
    this.pagePreviousIcon = require('@/assets/img/page_previous_icon.png')
    this.pageNextIcon = require('@/assets/img/page_next_icon.png')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.listWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  margin: 0;
  padding: 0;
  flex: 0.97;
}

.listContentWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  height: calc(100% - 82px);
}

.listHeader{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  height: 135px;
  padding: 70px 32px 0px 32px;
}

.listHeader .headerDiv {
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  height: 48px;
}

.headerInputDiv {
  display : -webkit-flex;
  display : flex;
  justify-content: start;
  align-items: center;
  width: 608px;
  height: 48px;
  border-radius: 10px;
  background-color: rgb(228,228,228);
}

.headerInputDiv > .headerInputSearchImg {
  cursor: pointer;
  height: 32px;
  width: 32px;
}

.headerInputDiv > .headerInputText {
  border: none;
  outline: none;
  width: 540px;
  height: 46px;
  border-radius: 10px;
  background-color: rgb(228,228,228);
  padding-left: 15px;
  font-size: 15px;
  outline: none;
}

.headerInputButton{
  cursor: pointer;
  height: 48px;
  width: 200px;
  border-radius: 8px;
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: bold;
  color: white;
  background-color: rgb(0,153,255);
}

.listHeader .headerSearchTextValidText {
  height: 20px;
}

.headerSearchTextValidText > span {
  font-size: 10px;
  color: red;
}

.listHeader .headerInfosDiv {
  display : -webkit-flex;
  display : flex;
  align-items: center;
  height: 40px;
  margin-bottom: 5px;
}

.headerInfo {
  flex: 0.16;
}

.headerInfo > .infoText{
  font-size: 11px;
  color: rgb(0,153,255);
}

.headerInfo > .infoValue{
  font-size: 12px;
  font-weight: bold;
}

.listDiv{
  display : -webkit-flex;
  display : flex;
  flex-wrap : wrap;
  align-content: flex-start;
  overflow-y: auto;
  flex: auto;
  padding: 0 16px 0 32px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.listDiv::-webkit-scrollbar{
  display: none;
}

.listFooter {
  text-align: center;
}

.pagePreviousDiv, .pageNextDiv {
  display: inline;
  vertical-align: middle;
}

.pagePreviousIcon, .pageNextIcon {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.page {
  cursor: pointer;
  text-decoration: underline;
  padding: 0 5px;
}

.selectedPage {
  font-weight: bold;
}

.listNoDataDiv {
  text-align: center;
  height: 100px;
  width: 100%;
  font-size: 11px;
  padding-top: 60px;
  color: #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/list.vue